export default "__VITE_ASSET__d4059312__"